/**
 * Desktop view only
 * */
const LARGE_SLOT_GROUP = 20;
/**
 * Widget and mobile modal views
 */
const SMALL_SLOT_GROUP = 15;
/**
 * CityMD max scheduling hours are 72 (3 days)
 */
const MAX_SCHEDULING_HOURS = 48;
/**
 * Limits availability displayed to user by this value (minutes)
 */
const SLOT_DISPLAY_TIME_BUFFER = 15;

export { MAX_SCHEDULING_HOURS, SMALL_SLOT_GROUP, LARGE_SLOT_GROUP, SLOT_DISPLAY_TIME_BUFFER };
